// extracted by mini-css-extract-plugin
export var statItem = "_ix-1";
export var statsRow = "_ix-0";